import { httpClaims } from 'utils/http'

import { IEntity, IEntityBag } from 'features/entities/types'

export const getEntities = async (url: string): Promise<IEntity[]> => {
  const { data } = await httpClaims.get(url)
  return data
}

export const getCallEntities = async (url: string): Promise<IEntityBag> => {
  const { data: entities } = await httpClaims.get(url)
  // The API returns a default entity bag from the claim, so only when we have 2 entity bags we have extracted entities
  const hasExtractedEntities = Array.isArray(entities?.data) && entities.data.length != 0
  return hasExtractedEntities
    ? entities?.data?.[0]
    : {
        entityVersions: [],
        actorId: '',
        actorName: '',
        activityId: '',
        remarks: '',
      }
}
